import { translate } from '@/domains/core/localization/translate';
export const {
  headerMenuProfileUrl,
  headerSubheaderContactB2bTelLink,
  headerSubheaderContactB2bTelNumber
} = translate({
  "headerMenuProfileUrl": "/account",
  "headerSubheaderContactB2bTelLink": "tel:+448081347752",
  "headerSubheaderContactB2bTelNumber": "080 8134 7752"
});